import Breadcrumb from "../components/Breadcrumb";
import EditWorkFlowLayer from "../components/EditWorkFlowLayer";

const EditWorkFlowPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Edit WorkFlow" />

      < EditWorkFlowLayer/>
    </>
  );
};

export default EditWorkFlowPage;
